import { api } from '@/shared/services/api';

export interface OnboardingProgressLists {
  seenTourIds: string[];
  completedTourIds: string[];
}

export class OnboardingHttpRepository {
  /** Lee el progreso del backend: tours vistos y completados (un completado también es visto). */
  async getProgress(): Promise<OnboardingProgressLists> {
    const response = await api.get<{ data: OnboardingProgressLists }>(
      '/v2/organizations/onboarding/progress'
    );
    return {
      seenTourIds: response.data.data.seenTourIds ?? [],
      completedTourIds: response.data.data.completedTourIds ?? [],
    };
  }

  async markSeen(tourId: string): Promise<void> {
    await api.post('/v2/organizations/onboarding/progress', { tourId, status: 'seen' });
  }

  async markCompleted(tourId: string): Promise<void> {
    await api.post('/v2/organizations/onboarding/progress', { tourId, status: 'completed' });
  }

  async reset(): Promise<void> {
    await api.delete('/v2/organizations/onboarding/progress');
  }
}
